<template>
  <div class="center-container">
    <slot/>
  </div>
</template>

<style scoped>
.center-container {
  padding-top: 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>


<script>
export default {
  name: "center-container"
};
</script>
